module.exports = __webpack_public_path__ + "3c565f659af5079576e2515be8b64456.png";